import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import Drawer from 'components/AntEnhancement/Drawer';
import SupplierForm from 'components/forms/inventory/suppliers/SupplierForm';
import localeTranslator from 'library/Hocs/LocalTranslator';
import { Supplier } from 'models';
import services from 'services';
import './SupplierDrawer.css';
var SupplierDrawer = function (props) {
    var visiable = props.visiable, onCloseDrawer = props.onCloseDrawer, t = props.translate;
    var supplier = useState(function () { return new Supplier(); })[0];
    var _a = useState(false), saving = _a[0], setSaving = _a[1];
    var form = Form.useForm()[0];
    var supplierService = services.supplierService;
    var createSupplier = supplierService.useCreateSupplier().mutate;
    var supplierTypes = supplierService.useSupplierTypes(visiable).data;
    useEffect(function () {
        if (!visiable)
            return;
        supplier.setName('');
        supplier.setEmail('');
        supplier.setSupplierType('');
        form.resetFields();
        setSaving(false);
    }, [visiable, supplier, form]);
    var onSubmit = function () {
        if (saving)
            return;
        supplier.setName((supplier.getName() || '').trim());
        supplier.setEmail((supplier.getEmail() || '').trim());
        setSaving(true);
        createSupplier({ supplier: supplier, successMessage: t('supplierCreated') }, {
            onSuccess: function () {
                setSaving(false);
                onCloseDrawer();
            },
            onError: function () { return setSaving(false); }
        });
    };
    return (_jsx(Drawer, { title: null, placement: "right", open: visiable, onClose: onCloseDrawer, closable: false, destroyOnClose: true, width: 440, rootClassName: "sup-drawer", className: "sup-drawer", children: _jsxs(Form, { form: form, layout: "vertical", className: "sup-drawer__shell", requiredMark: false, onFinish: onSubmit, children: [_jsxs("header", { className: "sup-drawer__header", children: [_jsxs("div", { className: "sup-drawer__title-block", children: [_jsx("span", { className: "sup-drawer__dot", "aria-hidden": true }), _jsxs("div", { children: [_jsx("h2", { className: "sup-drawer__title", children: t('title') }), _jsx("p", { className: "sup-drawer__subtitle", children: t('subtitle') })] })] }), _jsx("button", { type: "button", className: "sup-drawer__close", onClick: onCloseDrawer, "aria-label": t('common:buttons.close'), children: _jsx(CloseOutlined, {}) })] }), _jsx("div", { className: "sup-drawer__body", children: _jsx(SupplierForm, { supplier: supplier, supplierTypes: supplierTypes || [] }) }), _jsxs("footer", { className: "sup-drawer__footer", children: [_jsx("button", { type: "button", className: "sup-drawer__btn sup-drawer__btn--ghost", onClick: onCloseDrawer, children: t('common:buttons.cancel') }), _jsxs("button", { type: "submit", className: "sup-drawer__btn sup-drawer__btn--primary", disabled: saving, children: [_jsx(CheckOutlined, {}), _jsx("span", { children: saving ? t('saving') : t('common:buttons.submit') })] })] })] }) }));
};
export default localeTranslator(SupplierDrawer, 'supplierForm');
